import { Flex } from "@chakra-ui/react";

import { IChildrenProp } from "types/IChildrenProp";

interface IProps extends IChildrenProp {}

const MessageContainer = ({ children }: IProps) => {
  return (
    <Flex h="200px" alignItems="center" justifyContent="center">
      {children}
    </Flex>
  );
};

export { MessageContainer };
